import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AccountService, CredentialsService, MessageBase } from '../providers';
import { Directive, OnDestroy, inject, signal } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';

@Directive()
export class AquireNewPinBase implements OnDestroy {
  private readonly formBuilder: FormBuilder = inject(FormBuilder);

  public newPinForm: FormGroup = this.formBuilder.group({
    validateNewPin: new FormControl(false, Validators.requiredTrue),
    password: new FormControl('', Validators.required),
  });
  public requestSent = signal(false);

  protected readonly accountService: AccountService = inject(AccountService);
  protected readonly message: MessageBase = inject(MessageBase);
  protected readonly credentialsService: CredentialsService = inject(CredentialsService);

  private destroyed$: Subject<boolean> = new Subject();

  public get password(): AbstractControl<string> {
    return this.newPinForm.get('password') ?? new UntypedFormControl('');
  }

  public get validateNewPin(): AbstractControl<string> {
    return this.newPinForm.get('validateNewPin') ?? new UntypedFormControl('');
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  public submit(): void {
    const validateNewPin = this.validateNewPin?.value;
    const password = this.password?.value;

    if (validateNewPin && !!password) {
      this.sendRequest(password).pipe(takeUntil(this.destroyed$)).subscribe();
    }
  }

  protected sendRequest(password: string): Observable<boolean> {
    return this.accountService.sendNewPinForUser(password).pipe(
      tap(() => {
        this.requestSent.set(true);
        this.credentialsService.resetPin();
      }),
      catchError((error: string) => {
        this.message.showError({ message: error });
        return of(false);
      }),
    );
  }
}
